// extracted by mini-css-extract-plugin
export default {"resizeContainerWrapper":"resizeContainerWrapper---C34GO","ready":"ready---dkVP2","resizeContainerInner":"resizeContainerInner---Mimw7"};